import { gql } from 'apollo-angular';

export default gql`
  query GetOrderById($id: ID!) {
    getOrderById(id: $id) {
      id
      order_number
      confirmed_at
      consult_id
      is_urgent
      insole_plan_id
      manager_tenant_id
      manager_tenant_name
      manager_user_id
      patient_id
      patient_name
      patient_date_of_birth
      production_method
      shipping_target
      scan_2d_templates
      scan_3d_templates
      scan_pp_templates
      shipped_at
      status
      version_number
      workshop_tenant_id
      workshop_tenant_ref
    }
  }

  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      message
      success
    }
  }

  mutation UpdateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      id
      status
    }
  }

  mutation UpdateOrders($input: [UpdateOrderInput!]!) {
    updateOrders(input: $input) {
      id
      status
    }
  }

  query ListOrdersByWorkshopTenantId(
    $workshop_tenant_id: ID!
    $date_from: String
    $date_to: String
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByWorkshopTenantId(
      workshop_tenant_id: $workshop_tenant_id
      date_from: $date_from
      date_to: $date_to
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attachments
        confirmed_at
        consult_id
        created_at
        id
        insole_plan_id
        is_urgent
        material
        manager_tenant_id
        manager_tenant_name
        manager_tenant_ref
        manager_user_id
        order_number
        patient_id
        patient_name
        patient_date_of_birth
        production_method
        search_terms
        shipped_at
        shipping_target
        status
        workshop_tenant_id
        workshop_tenant_ref
        version_number
      }
      nextToken
      date_from
      date_to
    }
  }

  query ListOrdersByManagerTenantId(
    $manager_tenant_id: ID!
    $date_from: String
    $date_to: String
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByManagerTenantId(
      manager_tenant_id: $manager_tenant_id
      date_from: $date_from
      date_to: $date_to
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attachments
        confirmed_at
        consult_id
        created_at
        id
        insole_plan_id
        is_urgent
        manager_user_id
        manager_tenant_id
        manager_tenant_name
        manager_tenant_ref
        material
        order_number
        patient_id
        patient_name
        patient_date_of_birth
        production_method
        search_terms
        shipped_at
        shipping_target
        status
        workshop_tenant_id
        workshop_tenant_ref
        version_number
      }
      nextToken
      date_from
      date_to
    }
  }

  query ListOrdersByPatientId($patient_id: ID!, $limit: Int, $nextToken: String) {
    listOrdersByPatientId(patient_id: $patient_id, limit: $limit, nextToken: $nextToken) {
      items {
        attachments
        confirmed_at
        consult_id
        created_at
        id
        insole_plan_id
        is_urgent
        manager_user_id
        manager_tenant_id
        manager_tenant_name
        manager_tenant_ref
        material
        order_number
        patient_id
        patient_name
        patient_date_of_birth
        production_method
        search_terms
        shipped_at
        shipping_target
        status
        workshop_tenant_id
        workshop_tenant_ref
        version_number
      }
      nextToken
    }
  }

  query ListOrdersByPatientIdAndSearchTerms($patient_id: ID!, $search_terms: String, $limit: Int, $nextToken: String) {
    listOrdersByPatientIdAndSearchTerms(
      patient_id: $patient_id
      search_terms: $search_terms
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attachments
        confirmed_at
        consult_id
        created_at
        id
        insole_plan_id
        is_urgent
        manager_tenant_id
        manager_tenant_name
        manager_tenant_ref
        manager_user_id
        material
        order_number
        patient_id
        patient_name
        patient_date_of_birth
        production_method
        search_terms
        shipped_at
        shipping_target
        status
        workshop_tenant_id
        workshop_tenant_ref
        version_number
      }
      nextToken
    }
  }

  subscription OnOrderChanged($tenant_id: ID!) {
    onOrderChanged(tenant_id: $tenant_id) {
      id
      tenant_id
      event_type
    }
  }
`;
